export const userViewRecommendedPlanPage = email => ({
  type: 'User views Recommended Plan page',
  data: {
    customer_info: {
      email: email,
    },
  },
});

export const userContinuesFromRecommendedPlan = email => ({
  type: 'User continues from recommended plan',
  data: {
    customer_info: {
      email: email,
    },
  },
});

export const userClickCreateOwnPlan = email => ({
  type: 'User clicks creates own plan',
  data: {
    customer_info: {
      email: email,
    },
  },
});
